import {cloneDeep} from 'lodash'
import uuid from 'powtoon-commons/utils/uuid'
import {getFirstSprite} from 'powtoon-document/utils/trackSpriteUtils'
import {
  Track, TextTrack, TextTrackSprite, TrackSprite, CaptionsTrack, AudioTrack
} from 'powtoon-versioning/src/currentSchema'

type BaseTrack = Track | TextTrack | CaptionsTrack
type BaseSprite = TrackSprite | TextTrackSprite

export type TrackUpdateData = {
  extraTrackData?: Partial<BaseTrack>,
  newSprite?: BaseSprite,
  updateSpriteData?: Partial<BaseSprite>,
}

export const cloneAudioTrack =(audioTrack: AudioTrack): AudioTrack => {
  const clonedAudioTrack = cloneDeep(audioTrack)
  clonedAudioTrack.id = uuid()
  return clonedAudioTrack
}

export const cloneTrack = <T extends BaseTrack>(
  track: T,
  {
    extraTrackData = {},
    newSprite,
    updateSpriteData
  }: TrackUpdateData = {}
): T => ({
    ...track,
    id: uuid(),
    ...extraTrackData,
    sprites: [
      cloneSprite(getFirstSprite(track), newSprite, updateSpriteData)
    ]
  } as T
  )

export const cloneSprite = (
  sprite: BaseSprite,
  newSprite?: BaseSprite,
  updateSpriteData: Partial<BaseSprite> = {}
): BaseSprite => ({
  ...(newSprite || sprite),
  id: uuid(),
  ...updateSpriteData
}) as BaseSprite

export default cloneTrack
